import React, { useState } from "react";
import CarouselMovie from "./CarouselMovie";
import "./style.css";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import Calendar from "../../../features/Calendar";
import { format } from "date-fns";
import { pl } from "date-fns/locale";
import CinemaRepertoire from "./CinemaRepertoire";
import { useSaleMovieManager } from "./hooks/useSaleMovieManager";
import LoadableComponent from "../../../features/Loading/LoadableComponent";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import useLocaleByLanguage from "../../../utils/hooks/useLocaleByLanguage";

const SaleMovie: React.FC = () => {
  const isDesktop = useDesktopSize();
  const locale = useLocaleByLanguage();
  const [date, setDate] = useState<Date>(new Date());
  const { shows, loading } = useSelector((state: State) => state.shows);
  const { t } = useTranslation();

  const { loading: loadingShow, showsByDate, getShowsByDate } = useSaleMovieManager();

  const handleChangeDate = (date: Date) => {
    setDate(date);
    getShowsByDate(date);
  };

  return (
    <div className={isDesktop ? "movie-panel" : "movie-panel-mobile"}>
      <div className={"facility-panel"}>
        <p>
          {t("kino")}:<span>Test Rzeszów</span>
        </p>
      </div>

      <div className={"carousel-movie-panel"}>
        <h3>{t("repertuar")}</h3>
        <LoadableComponent loading={loading}>
          <CarouselMovie movieList={shows} />
        </LoadableComponent>
      </div>

      <div className={"calendar-movie-panel"}>
        <p id={"title-calendar"}>
          {t("teraz_gramy")} | Test Rzeszów | {format(date, "EEEE dd.MM", { locale: locale })}
        </p>
        <Calendar onChangeDate={handleChangeDate} />
        <CinemaRepertoire date={date} loading={loadingShow} movieList={showsByDate} />
      </div>
    </div>
  );
};

export default SaleMovie;
